import React from "react";
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../Components/ui/form";
function FormFieldItem(props) {
  // Check if label is a React element (div) - if so, don't add asterisk via FormLabel
  const isLabelElement = React.isValidElement(props.label);
  
  return (
    <FormItem className={props.className}>
      <FormLabel required={props.required && !isLabelElement}>{props.label}</FormLabel>
      <FormControl>{props.children}</FormControl>
      <FormDescription className="text-xs" >{props.description}</FormDescription>
      <FormMessage />
    </FormItem>
  );
}

export default FormFieldItem;
